// Only add common function that required for API

import { getLocalStorageItem } from '../shared-functions/LocalStorage';

/**
 * Function to get auth token from cookie
 */
const getEventControlKey = () => {
  const accessToken = getLocalStorageItem('guestToken');
  if (accessToken) {
    return accessToken;
  }
  return null;
};

/**
 * Function to get auth token from cookie
 */
const getToken = () => {
  const accessToken = getEventControlKey();
  if (accessToken) {
    return accessToken;
  }
  return null;
};

// Change when adding new functions
export default getToken;
